module.exports = __webpack_public_path__ + "img/e-genting-2018.6afbf07c.png";